module.exports = __webpack_public_path__ + "img/7m2.e676306a.jpg";